import addBrTagBeforeText from "../global_helper/global_helper";
import styles from "./ShopItemSection.module.css";
import SingleSubProduct from "./SingleSubProduct";
import { useState } from "react";
const ShopItemSection = ({ setCartChanged, open_popup, detail, locked }) => {
  const [images, setImages] = useState(detail.category_images);
  const itemTitle = detail.category_name;
  const searchText = '※2022年より三面台紙の表紙はグレーにリニューアルしました。二面台紙の表紙は水色です。';
  const itemDescription = addBrTagBeforeText(detail.category_description, searchText) ;
  const products = detail.products;
  return (
    <>
      <div className={styles.section_top_space}></div>
      <div className={`${styles.title_image_container} w-100 d-flex container`}>
        <div
          className={`carousel slide ${styles.main_image} ${styles.carousel_main_pic}`}
        >
          <img src={images[0]} alt="" />

          <span
            className="carousel-control-prev"
            role="button"
            data-slide="prev"
          >
            <span
              className={`${styles.carousel_control_prev_icon} material-icons`}
              aria-hidden="true"
              onClick={() => {
                const temp = [...images];
                console.log("OLD images:");
                console.log(temp);
                const tempItem = temp.shift();
                temp.push(tempItem);
                console.log("NEW images");
                console.log(temp);
                setImages(temp);
              }}
            >
              <span className={`${styles.arrow_icon} material-icons`}>
                keyboard_arrow_left
              </span>
            </span>
            <span className="sr-only">Previous</span>
          </span>
          <span
            className="carousel-control-next"
            // href="#carouselExampleControls"
            role="button"
            data-slide="next"
          >
            <span
              className={`${styles.carousel_control_next_icon} `}
              aria-hidden="true"
              onClick={() => {
                const temp = [...images];
                const tempItem = temp.pop();
                temp.unshift(tempItem);
                console.log(temp);
                setImages(temp);
              }}
            >
              <span className={`${styles.arrow_icon} material-icons`}>
                keyboard_arrow_right
              </span>
            </span>
            <span className="sr-only">Next</span>
          </span>
        </div>
        <div id={itemTitle} className={`ml-4 ${styles.product_info}`}>
          <div className={`${styles.tag_div} badge badge-pill`}>
            <div className={styles.tag_heading}>{itemTitle}</div>
            {detail.sale_status && (
              <div className={styles.tag_heading_sale}>SALE</div>
            )}
          </div>
          <div className={styles.space_tag_content}></div>
          <div className={styles.item_description_content}>
            {/* {detail.products[0]} */}
            {detail.sale_status && detail.products[0].sale_info && (
              <div className={styles.tag_heading_sale_text}>
                {detail.products[0].sale_info.sale_text}
              </div>
            )}
            {itemDescription}
          </div>
          <div
            className={` d-flex justify-content-around ${styles.product_image_gallery}`}
          >
            {/* {Array.isArray(images) &&
              images.length > 0 &&
              images.map((item, index) => {
                if (index === 0) return;
                return (
                  <div
                    key={index}
                    className={styles.img_thumbnail}
                    style={{
                      width: "70px",
                      height: "70px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={item}
                      alt=""
                      style={{ width: "70px", display: "block" }}
                    />
                  </div>
                );
              })} */}
            {[0, 1, 2, 3, 4].map((number) => {
              console.log(images, "test");
              return (
                <div
                  key={number}
                  className={styles.img_thumbnail}
                  style={{
                    width: "70px",
                    height: "70px",
                    overflow: "hidden",
                    border: images[number] ? "0px" : "1px solid #70707073",
                  }}
                >
                  {images[number] ? (
                    <img
                      src={images[number]}
                      alt=""
                      style={{ width: "70px", display: "block" }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className={styles.subproduct_wrapper}>
        <div className={`${styles.subproduct_container} container`}>
          {Array.isArray(products) &&
            products.length > 0 &&
            products.map((item, index) => {
              return (
                <>
                  <SingleSubProduct
                    setCartChanged={setCartChanged}
                    key={index}
                    productCode={item.product_code}
                    title={item.title}
                    price={item.sale_price}
                    favorite={item.is_favorite}
                    data={item}
                    locked={locked}
                    open_popup={open_popup}
                  ></SingleSubProduct>
                  {item.product_code.toLowerCase().startsWith("wp") &&
                    index === 3 && (
                      <hr
                        className="my-5"
                        style={{
                          border: "1px solid #707070",
                          opacity: 0.45,
                          width: "1030px",
                        }}
                      />
                    )}
                  {item.product_code.toLowerCase().startsWith("da") &&
                    index === 1 && (
                      <hr
                        className="my-5"
                        style={{
                          border: "1px solid #707070",
                          opacity: 0.45,
                          width: "750px",
                          marginLeft: "280px",
                        }}
                      />
                    )}
                  {item.product_code.toLowerCase().startsWith("da") &&
                    index === 3 && (
                      <>
                        <div className={styles.mountInfoText}>
                          三面台紙は、お写真を３カットまたは４カットお選びいただけます。
                          <br />
                          お得な3冊セットは、3冊それぞれ別のお写真をお選びいただけます。
                        </div>
                        <hr
                          className="my-5"
                          style={{
                            border: "1px solid #707070",
                            opacity: 0.45,
                            width: "750px",
                            marginLeft: "280px",
                          }}
                        />
                      </>
                    )}
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default ShopItemSection;
